// One home for stringifying caught unknowns for the UI.
export function errorMessage(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}
